<template>
    <div class="flex flex-row items-center">
        <div>
            <FormInput type="select" :options="years" v-model="year" autocomplete="bi-inp-year" disable-un-select placeholder="2000" />
        </div>
        <div>年</div>
        <div>
            <FormInput type="select" :options="months" v-model="month" autocomplete="bi-inp-month" disable-un-select />
        </div>
        <div>月</div>
        <div>
            <FormInput type="select" :options="days" v-model="day" autocomplete="bi-inp-day" disable-un-select />
        </div>
        <div>日</div>
    </div>
</template>

<script>
import moment from "moment";
import FormInput from "./FormInput";

export default {
    name: "BirthdayInput",
    components: {FormInput},

    props: {
        value: {
            type: String
        }
    },

    data() {
        return {
            year: null,
            month: null,
            day: null,
        }
    },

    watch: {
        year: function () {
            this.onUpdate();
        },

        month: function () {
            this.onUpdate();
        },

        day: function () {
            this.onUpdate();
        },

        value: function () {
            this.onReverse();
        }
    },

    computed: {
        years() {
            const range = (start, end) => [...Array((end - start) + 1)].map((_, i) => start + i);
            const start = parseInt(moment().subtract(80, 'years').format('YYYY'));
            const end = parseInt(moment().format('YYYY'));
            return range(start, end).map(year => ({
                value: year,
                label: `${year}`.slice(0, 4),
            }));
        },

        months() {
            const range = (start, end) => [...Array((end - start) + 1)].map((_, i) => start + i);
            return range(1, 12).map(month => ({
                value: `00${month}`.slice(-2),
                label: month,
            }));
        },
        days() {
            const range = (start, end) => [...Array((end - start) + 1)].map((_, i) => start + i);
            return range(1, 31).map(day => ({
                value: `00${day}`.slice(-2),
                label: day,
            }));
        },
    },

    mounted() {
        this.onReverse();
    },

    methods: {
        onUpdate() {
            this.$emit('input', `${this.year}${this.month}${this.day}`);
        },

        onReverse() {
            if (/^\d{8}$/.test(this.value)) {
                this.year = this.value.slice(0, 4);
                this.month = this.value.slice(4, 6);
                this.day = this.value.slice(-2);
            }
        },
    }
}
</script>

<style scoped>

</style>
